export const isTouchDevice = () => {
  return (
    "ontouchstart" in window || navigator.maxTouchPoints > 0
    // https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/1029
    // || navigator.msMaxTouchPoints > 0
  );
};
